$ = jQuery;

/**
 * Cliques em tags
 */
$(".jc-post-tag a").on('click', function() {

  dataLayer.push({
    'event': 'eventGA',
    'eventCategory': 'Post',
    'eventAction': 'Clique - Tag',
    'eventLabel': $(this).text()
  });

  gtag('event', 'Post', {
    'eventAction': 'Clique - Tag',
    'eventLabel': $(this).text()
  });
});